const set = require('regenerate')(0x951, 0x1CD7, 0x1CD9, 0x1CE0);
set.addRange(0x1CDC, 0x1CDD).addRange(0x11180, 0x111DF);
exports.characters = set;
